// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZR7y","actions":"styles_actions__2MWS7","error":"styles_error__InZne","message":"styles_message__3INLo"};